module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_zalvan_sm-c60bb8ff878eb9d990db6080d16c4e07.png";